"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var _404_error_svg_1 = __importDefault(require("../../assets/img/error/404-error.svg"));

var server_error_svg_1 = __importDefault(require("../../assets/img/error/server-error.svg"));

var vip_access_svg_1 = __importDefault(require("../../assets/img/error/vip-access.svg"));

var no_result_svg_1 = __importDefault(require("../../assets/img/error/no-result.svg"));

exports.Error = function (_a) {
  var children = _a.children,
      title = _a.title,
      subtitle = _a.subtitle,
      errorType = _a.errorType,
      searchError = _a.searchError;
  var errorImage = '';

  switch (errorType) {
    case 'not-found':
      errorImage = _404_error_svg_1.default;
      break;

    case 'no-result':
      errorImage = no_result_svg_1.default;
      break;

    case 'server-error':
      errorImage = server_error_svg_1.default;
      break;

    case 'access-denied':
      errorImage = vip_access_svg_1.default;
      break;

    default:
      errorImage = _404_error_svg_1.default;
  }

  return searchError ? react_1.default.createElement("div", {
    className: "h-100 pt-2 m-auto bg-white error-container no-result"
  }, react_1.default.createElement("div", {
    className: "row justify-content-center"
  }, react_1.default.createElement("div", {
    className: "col-4"
  }, react_1.default.createElement("img", {
    src: errorImage,
    alt: errorType
  }))), react_1.default.createElement("div", {
    className: "row justify-content-center"
  }, react_1.default.createElement("div", {
    className: "col-8 pt-1"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    weight: "medium",
    className: "text-center"
  }, title), children))) : react_1.default.createElement("div", {
    className: "bg-white row h-100 py-5 m-auto error-container"
  }, react_1.default.createElement("div", {
    className: "d-md-none col-8 mx-auto"
  }, react_1.default.createElement("img", {
    src: errorImage,
    alt: errorType
  })), react_1.default.createElement("div", {
    className: "col-12 col-md-8 pt-5"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "huge"
  }, title), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    weight: "medium"
  }, subtitle), children), react_1.default.createElement("div", {
    className: "d-none d-md-block col-4"
  }, react_1.default.createElement("img", {
    src: errorImage,
    alt: errorType
  })));
};

exports.default = exports.Error;